// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "社会保障学",
      "tec": "赵晗",
      "week": "1,3,5,7,9周",
      "add": "教学楼D座313文法"
    },
    [
      {
        "sub": "风险管理学",
        "tec": "姜欣",
        "week": "1-12周",
        "add": "教学楼D座228经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "王星月",
        "week": "13周",
        "add": "教学楼D座313文法"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "孙新",
      "week": "1-8周",
      "add": "教学楼A座122信息"
    },
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "黄玉东张翼",
      "week": "1-8周",
      "add": "教学楼C座212教务"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "海上保险",
        "tec": "吕阳",
        "week": "1-12周",
        "add": "教学楼D座228经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "王星月",
        "week": "13周",
        "add": "教学楼D座313文法"
      }
    ],
    [
      {
        "sub": "保险会计",
        "tec": "姜欣",
        "week": "1-12周",
        "add": "教学楼D座214经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "王星月",
        "week": "13周",
        "add": "教学楼D座313文法"
      }
    ],
    {
      "sub": "保险营销与策划",
      "tec": "王冰",
      "week": "1-11周",
      "add": "教学楼D座223经管"
    },
    {
      "sub": "国家安全教育",
      "tec": "孙新",
      "week": "8-9,11-12周",
      "add": "教学楼A座122信息"
    },
    0
  ],
  "3": [
    {
      "sub": "社会保障学",
      "tec": "赵晗",
      "week": "1-11周",
      "add": "教学楼D座328经管"
    },
    {
      "sub": "风险管理学",
      "tec": "姜欣",
      "week": "1-12周",
      "add": "教学楼D座324经管"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "责任保险理论与实务",
      "tec": "薛睿",
      "week": "1-12周",
      "add": "教学楼D座214经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "孙新",
        "week": "1-8周",
        "add": "教学楼A座222电力"
      },
      {
        "sub": "保险会计",
        "tec": "姜欣",
        "week": "9-12周",
        "add": "教学楼D座224经管"
      }
    ],
    {
      "sub": "团体保险实务",
      "tec": "孙敬延",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    {
      "sub": "就业创业指导",
      "tec": "王星月",
      "week": "2,4,6-8周",
      "add": "教学楼D座215经管"
    },
    0
  ],
  "5": [
    0,
    {
      "sub": "保险营销与策划",
      "tec": "王冰",
      "week": "1-5周",
      "add": "教学楼D座221经管"
    },
    {
      "sub": "国家安全教育",
      "tec": "孙新",
      "week": "8-9,11-12周",
      "add": "教学楼A座322电力"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
